import React from 'react';

export const LogsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
  >
    <defs>
      <path
        id="logs-icon-a"
        d="M.458 13h2.124A8.003 8.003 0 0 0 18 10 8 8 0 0 0 2.582 7H.458C1.732 2.943 5.522 0 10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10c-4.478 0-8.268-2.943-9.542-7zm8.158.016l1.988-1.988H1.006a1.006 1.006 0 0 1-1.013-1.013c0-.565.448-1.013 1.013-1.013h9.54l-1.93-1.968a1.035 1.035 0 0 1 0-1.442c.39-.39 1.053-.39 1.442 0l3.683 3.741c.39.39.39 1.052 0 1.442l-3.683 3.683c-.39.39-1.052.39-1.442 0a1.034 1.034 0 0 1 0-1.442z"
      />
    </defs>
    <use fillRule="evenodd" xlinkHref="#logs-icon-a" />
  </svg>
);
